import { useConnectModal } from '@rainbow-me/rainbowkit'

const useWalletModal = () => {
  const { openConnectModal } = useConnectModal()

  return { openWalletModal: openConnectModal }
}

export default useWalletModal
